<template>
  <div>
    <!-- Table Container Card -->
    <model-list-table
      :store-module-name="storeModuleName"
      :table-columns="tableColumns"
      :filters-list="filtersList"
      :query-params="getQueryParams"
      add-action="sidebar"
      :view-action="false"
      :edit-action="false"
      :delete-action="true"
      :extra-actions="[]"
      :sidebar="SidebarAddTeamMember"
      :is-sortable="false"
    />
  </div>
</template>

<script>
import store from '@/store'
import { onUnmounted } from 'vue'
import { formatDate } from '@core/utils/filter'
import ModelListTable from '@/views/models/common/ModelListTable.vue'
import SidebarAddTeamMember from '@/views/models/team/add/SidebarAddTeamMember.vue'
import teamStoreModule from '../teamStoreModule'

export default {
  components: {
    ModelListTable,
  },
  setup() {
    const STORE_MODULE_NAME = 'team_members'

    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, teamStoreModule)

    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const tableColumns = [
      {
        key: 'checkbox',
        label: '',
        sortable: false,
      },
      { key: 'customer', sortable: false, label: 'modules.team_members.s_c' },
      {
        key: 'email',
        label: 'inputs.email',
        sortable: false,
      },
      {
        key: 'created_at',
        label: 'Creation Date',
        formatter: formatDate,
        sortable: true,
      },
      { key: 'is_active', sortable: false, label: 'Status' },
      { key: 'actions' },
    ]

    const filtersList = []
    const getQueryParams = () => ({})

    return {
      tableColumns,
      storeModuleName: STORE_MODULE_NAME,
      filtersList,
      getQueryParams,

      SidebarAddTeamMember,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
